module.exports = __webpack_public_path__ + "media/coffee-preferences/sub_flavor_floral_chamomile-0f3c6a42.png";